<template>
  <div class="modal fade" id="branchDepartmentCreateUpdateModel" tabindex="-1" aria-labelledby="branchDepartmentCreateUpdateModelLabel" aria-hidden="true" @keydown.esc="clearForm">
    <div class="modal-dialog">
      <div class="modal-content" v-if="!loaded">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="branchDepartmentCreateUpdateModelLabel">
            <span v-if="modalData.title" class="text-gray-600" v-html="modalData.title"></span>
            <span v-else class="text-gray-600">Новый филиал</span>
          </h5>
          <button @click="clearForm" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
          <div v-if="error" class="alert alert-danger d-flex align-items-center px-5 py-3">
            <span v-html="error"></span>
          </div>
          <form @submit.prevent="addDepartment">
            <div>
              <input-field
                  v-model="this.form.c_id"
                  :required="true"
                  :mb="5"
                  id="dep.form.c_id"
                  name="dep.form.c_id"
                  placeholder="1C ID"
                  type="text"
              />
              <area-field
                  v-model="this.form.title"
                  :required="true"
                  :mb="5"
                  :class="'h-125px'"
                  id="dep.form.title"
                  name="dep.form.title"
                  placeholder="Название"
              />
              <div class="custom-select dynamic" v-if="getDTerminals">
                <label for="form.terminal_id">Терминал</label>
                <v-select
                    v-model="form.terminal_id"
                    input-id="form.terminal_id"
                    :options="getDTerminals"
                    :reduce="item => item.id"
                    placeholder="Выберите..."
                    class="mb-5 bg-gray-100 form rounded"
                    label="name"
                />
              </div>
              <div class="custom-select dynamic" v-if="getDHeads">
                <label for="form.head_id">Начальник</label>
                <v-select
                    v-model="form.head_id"
                    input-id="form.head_id"
                    :options="getDHeads"
                    :reduce="item => item.id"
                    placeholder="Выберите..."
                    class="mb-5 bg-gray-100 form rounded"
                    label="name"
                />
              </div>
              <div class="custom-select dynamic" v-if="getDDepartments">
                <label for="form.parent_id">Привязано к</label>
                <v-select
                    v-model="form.parent_id"
                    input-id="form.parent_id"
                    :options="getDDepartments"
                    :reduce="item => item.id"
                    placeholder="Выберите..."
                    class="mb-5 bg-gray-100 form rounded"
                    label="name"
                />
              </div>
              <div class="row">
                <div class="col-6">
                  <select-field-from-model
                      v-model="this.form.status"
                      :options="[{id: 1, name: 'Активный'},{id: 0, name: 'Неактивный'}]"
                      :required="true"
                      id="dep.form.status"
                      name="dep.form.status"
                      placeholder="Статус"
                  />
                </div>
                <div class="col-6">
                  <select-field-from-model
                      v-model="this.form.type"
                      :options="[{id: 0, name: 'Нет 1C'},{id: 1, name: 'C 1C'},{id: 2, name: 'Локальный'}]"
                      :required="true"
                      id="dep.form.type"
                      name="dep.form.type"
                      placeholder="Тип"
                  />
                </div>
              </div>
              <div class="mt-5 text-center">
                <button
                    :disabled="this.error"
                    type="submit"
                    class="btn btn-sm btn-primary"
                >Сохранить</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="min-height: 319px"/>
      </div>
    </div>
  </div>
</template>

<script>
import SelectFieldFromModel from '@/components/Fields/SelectFieldFromModel'
import InputField           from '@/components/Fields/InputField'
import LoaderFull           from '@/components/Main/LoaderFull'
import AreaField            from "@/components/Fields/AreaField.vue";
// Other
import axios                from 'axios'
import vSelect              from 'vue-select'

export default {
  name: 'BranchDepartmentCreateUpdateModel',
  components: { AreaField, SelectFieldFromModel, LoaderFull, InputField, vSelect },
  props: {
    page: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loaded: false,
      error:  null,
      form: {
        terminal_id:   null,
        parent_id:     null,
        head_name:     null,
        head_id:       null,
        status:        1,
        title:         null,
        c_id:          null,
        type:          2,
      }
    }
  },
  computed: {
    getDDepartments() { return this.$store.getters.getDepartmentsDic },
    getDTerminals()   { return this.$store.getters.getTerminalsDic },
    getDHeads()       { return this.$store.getters.getHeadDic },
    modalData()       { return this.$store.getters.getBranchDepartmentCreateUpdateModel },
  },
  methods: {
    addDepartment() {
      this.loaded = true
      const data = {form:this.form, isEdit: this.modalData.isEdit, id:this.modalData.id}
      axios.post('/api/branches/create-department', data)
          .then(res => {
            if (res.data.result) {
              this.$emit('reloaded', this.page)
              this.modalHidden()
            } else {
              this.error = res.data.message
            }
          })
          .catch(err => {
            if (err.response) {
              this.error = err.response.data.message
            } else {
              this.error = err.message
            }
          })
          .finally(() => this.loaded = false)
    },
    clearForm() {
      this.form = {
        terminal_id:   null,
        parent_id:     null,
        head_name:     null,
        head_id:       null,
        status:        1,
        title:         null,
        c_id:          null,
        type:          2,
      }
      this.loaded        = false
      this.error         = null
    },
    getItem(id, isEdit) {
      if (isEdit) {
        this.loaded = true
        axios.post('/api/branches/department-item', {id:id})
            .then(res => {
              if (res.data.result) {
                if (isEdit) {
                  this.form = res.data.data
                  this.isDep = res.data.isDep
                }
              }
            })
            .catch(err => {
              console.log(err)
            })
            .finally(() => {this.loaded = false})
      }
    },
    modalHidden() {
      const myModalEl = document.getElementById('branchDepartmentCreateUpdateModel');
      const modal     = bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
      this.clearForm()
    }
  },
  watch: {
    modalData: {
      deep: true,
      handler(newValue) {
        this.clearForm()
        this.getItem(newValue.id, newValue.isEdit)
      }
    }
  }
}
</script>

<style scoped>

</style>